import classnames from 'classnames';
import React from 'react';
import { Link } from 'react-router-dom';
import useComponentVisible from '~/hooks/useComponentVisible';
import { useComparisonGrid } from '../providers/comparison_grid';
import { useDocumentComparison } from '../providers/document_comparsion';
const AnchorColumnHeader = () => {
    const { setAnchorDocId } = useDocumentComparison();
    const { anchorDoc, comparatorDocs } = useComparisonGrid();
    const { ref: showHideRef, isComponentVisible: isAnchorSelectOpen, setIsComponentVisible: setIsAnchorSelectOpen, } = useComponentVisible(false);
    return React.createElement("div", { className: 'header cell anchor-title', title: 'Switch Anchor Document', "data-testid": 'cell-0-1', onClick: () => setIsAnchorSelectOpen(!isAnchorSelectOpen) },
        React.createElement("span", { className: 'icon' },
            React.createElement("i", { className: 'fa-star fas' })),
        React.createElement(Link, { className: 'overflow-ellipsis', "data-testid": 'anchor-document-link', to: `/document/${anchorDoc.fileId}`, target: '_blank', title: anchorDoc.fileName }, anchorDoc.fileName),
        isAnchorSelectOpen && (React.createElement("div", { className: 'anchor-switch-dropdown', "data-testid": 'anchor-document-switcher-dialog', ref: showHideRef }, [anchorDoc, ...comparatorDocs].map((doc, index) => {
            const isSelectedAnchorDoc = doc.documentComparisonFileId === anchorDoc.documentComparisonFileId;
            const itemClass = classnames('select-item', {
                selected: isSelectedAnchorDoc,
            });
            return (React.createElement("div", { "data-testid": `anchor-doc-switcher-doc-${index}`, key: `${doc.documentComparisonFileId}-anchor-select`, className: itemClass, onClick: () => setAnchorDocId(doc.documentComparisonFileId) },
                React.createElement("span", { className: 'icon' }, isSelectedAnchorDoc && (React.createElement("i", { className: 'fas fa-star' }))),
                React.createElement("span", { className: 'overflow-ellipsis', title: doc.fileName }, doc.fileName)));
        }))));
};
export default AnchorColumnHeader;
